/**
 * ?mock=1 の間、画面上部に常時表示する警告バナー。
 * fixtureの数値・文言を実績データと誤認しないための注意喚起（推奨WARNINGS対応）。
 */
export function MockBanner() {
  return (
    <div className="mock-banner" role="status">
      モックデータ表示中（?mock=1） — 表示されている数値・文言はすべてダミーです。実績ではありません。
    </div>
  );
}
